import { t } from '@lingui/core/macro';
import { Button } from 'src/components/ui';
import Icon from 'src/components/Icon';
import useToggleAll from './useToggleAll';

// Renders a "select all / deselect all" control for one boolean array-item
// column (`ui:includeToggleAll: true`). Used both as a header-cell button in
// TableLayout, and (with a `label`) in CardsLayout's toolbar, since cards have
// no per-column header to attach the button to.
function ToggleAllButton({ field, label, ...arrayProps }) {
  const { allChecked, someChecked, toggleAll, disabled } = useToggleAll({ field, ...arrayProps });

  const icon = allChecked ? 'CheckSquare' : someChecked ? 'MinusSquare' : 'Square';
  const title = allChecked ? t`Deselect all` : t`Select all`;

  return (
    <Button
      type="button"
      color="clear"
      size="sm"
      className="array-toggle-all p-0"
      onClick={toggleAll}
      disabled={disabled}
      title={title}
      aria-label={title}
    >
      <Icon icon={icon} />
      {label ? <span className="array-toggle-all-label ml-1">{label}</span> : null}
    </Button>
  );
}

export default ToggleAllButton;
